import { userConstants } from '../_constants';

export function signinReducer(state = {}, action) {
  switch (action.type) {
    case userConstants.SIGNIN_REQUEST:
      return {
        loggingin: true
      }
    case userConstants.SIGNIN_SUCCESS:
      return {
        loggedin: true
      }
    case userConstants.SIGNIN_FAILURE:
      return {
        loggedin: false
      }
    default:
      return {
        state: {}
      }
  }
}

export function signupReducer(state = {}, action) {
  switch (action.type) {
    case userConstants.SIGNUP_REQUEST:
      return {
        registering: true
      }
    case userConstants.SIGNUP_SUCCESS:
      return {
        registered: true
      }
    case userConstants.SIGNUP_FAILURE:
      return {
        registered: false
      }
    default:
      return {
        state: {}
      }
  }
}

export function resetPasswordReducer(state = {}, action) {
  switch (action.type) {
    case userConstants.PASSWORD_RECOVERY_REQUEST:
      return {
        recovering: true
      }
    case userConstants.PASSWORD_RECOVERY_SUCCESS:
      return {
        recovered: true
      }
    case userConstants.PASSWORD_RECOVERY_FAILURE:
      return {
        recovered: false
      }
    default:
      return {
        state: {}
      }
  }
}